import AdminPost from "../../../../content/articles/2014-12-18-building-an-admin-section-in-rails/admin-post.png";
import React from 'react';
export default {
  AdminPost,
  React
};